import React, { forwardRef } from 'react'
import { withStyles } from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'
import PropTypes from 'prop-types'

import { standardBodyFont } from '../../themes'
import { translate } from '../../multilanguage'

const StyledMenuItemBase = withStyles(theme => ({
  root: {
    ...standardBodyFont(theme),
    ...props => props.style
  },
}))(MenuItem)

const MenuItemBase = forwardRef((props, ref) => {
  const {
    noTranslate,
    ...finalProps
  } = props
  return (
    <StyledMenuItemBase
      color='default'
      {...finalProps}
      ref={ref}
    >
      {typeof props.children !== 'string' ? props.children : props.noTranslate ? props.children : translate(props.children)}
    </StyledMenuItemBase>
  )
})

MenuItemBase.propTypes = {  
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  noTranslate: PropTypes.bool,
}

export default MenuItemBase